
import {getModule, Module, Mutation, MutationAction, VuexModule} from "vuex-module-decorators";
import store from "@/store";
@Module({
    namespaced: true,
    name: "appForms",
    store,
    dynamic: true,
})
class appForms extends VuexModule {
    boxData: any[] = [];
    status:boolean =false;

    @Mutation
    addData(data:any){
        this.boxData.push(data)
    }

    @Mutation
    setReady() {
        this.status = true
    }

    @Mutation
    setNotReady() {
        this.status = false
    }

    @Mutation
    clearData(){
        this.boxData = [];
    }
    @Mutation
    deleteData(index:number){
        this.boxData.splice(index, 1);
    }
}
export const AppFormsStore = getModule(appForms);
